import { defineMessages } from '../define';

/** Sign-in, invite/reset links, Home-Screen guide, first-run onboarding and the avatar editor. */
export const auth = defineMessages(
  {
    // Shared chrome
    'auth.lang.label': 'Tungumál',
    'auth.lang.is': 'Íslenska',
    'auth.lang.en': 'English',
    'auth.tagline': 'Nótur, æfingar og dagatal kórsins',
    'auth.logo_alt': 'Merki Karlakórs Grafarvogs',
    'auth.wait_seconds': {
      one: 'Of margar tilraunir. Reyndu aftur eftir {count} sekúndu.',
      other: 'Of margar tilraunir. Reyndu aftur eftir {count} sekúndur.',
    },
    'auth.wait_minutes': {
      one: 'Of margar tilraunir. Reyndu aftur eftir {count} mínútu.',
      other: 'Of margar tilraunir. Reyndu aftur eftir {count} mínútur.',
    },

    // Password field
    'auth.password.show': 'Sýna lykilorð',
    'auth.password.hide': 'Fela lykilorð',
    'auth.password.caps': 'Hástafalás er á',

    // Login
    'auth.login.title': 'Innskráning',
    'auth.login.email': 'Netfang',
    'auth.login.password': 'Lykilorð',
    'auth.login.submit': 'Skrá inn',
    'auth.login.busy': 'Skrái inn…',
    'auth.login.slow': 'Þetta getur tekið nokkrar sekúndur á eldri tækjum.',
    'auth.login.missing': 'Sláðu inn netfang og lykilorð.',
    'auth.login.bad_email': 'Netfangið virðist ekki rétt slegið inn.',
    'auth.login.forgot_title': 'Gleymt lykilorð?',
    'auth.login.forgot': 'Hafðu samband við stjórnanda kórsins og fáðu nýjan hlekk.',
    'auth.login.install_link': 'Hvernig set ég appið á heimaskjáinn?',

    // Invite / reset link
    'auth.accept.checking': 'Athuga hlekkinn…',
    'auth.accept.welcome': 'Velkomin(n), {name}!',
    'auth.accept.invite_intro': 'Veldu þér lykilorð til að virkja aðganginn þinn að appi kórsins.',
    'auth.accept.reset_title': 'Nýtt lykilorð',
    'auth.accept.reset_intro': 'Hæ {name}. Veldu nýtt lykilorð fyrir aðganginn þinn.',
    'auth.accept.email': 'Netfangið þitt',
    'auth.accept.email_hint': 'Þú skráir þig inn með þessu netfangi.',
    'auth.accept.password': 'Nýtt lykilorð',
    'auth.accept.repeat': 'Endurtaktu lykilorðið',
    'auth.accept.rule': 'Minnst {min} stafir. Gott ráð: nokkur orð saman, t.d. „sól hestur kaffi Esja“.',
    'auth.accept.count': '{count} / {min} stafir',
    'auth.accept.too_short': 'Lykilorðið þarf að vera minnst {min} stafir.',
    'auth.accept.too_common': 'Þetta lykilorð er of algengt. Veldu annað.',
    'auth.accept.mismatch': 'Lykilorðin eru ekki eins.',
    'auth.accept.submit': 'Vista lykilorð',
    'auth.accept.busy': 'Vista lykilorð…',
    'auth.accept.other_user':
      'Þú ert skráð(ur) inn sem {name} á þessu tæki. Ef þú heldur áfram verður sá aðgangur skráður út hér.',
    'auth.accept.invalid_title': 'Hlekkurinn virkar ekki',
    'auth.accept.invalid_body':
      'Hann er útrunninn eða hefur þegar verið notaður. Biddu stjórnanda kórsins um nýjan hlekk.',
    'auth.accept.to_login': 'Fara á innskráningu',
    'auth.accept.done_title': 'Lykilorðið er vistað!',
    'auth.accept.done_body': 'Eitt skref enn: settu appið á heimaskjáinn svo það sé alltaf við höndina.',
    'auth.accept.continue_browser': 'Halda áfram í vafranum',

    // Invite link by voice (sign up)
    'auth.signup.title': 'Velkomin(n) í Karlakór Grafarvogs!',
    'auth.signup.intro': 'Skráðu upplýsingarnar þínar og veldu lykilorð til að búa til aðgang að appi kórsins.',
    'auth.signup.voice': 'Rödd',
    'auth.signup.title_label': 'Titill',
    'auth.signup.name': 'Fullt nafn',
    'auth.signup.name_required': 'Sláðu inn nafnið þitt.',
    'auth.signup.email': 'Netfang',
    'auth.signup.email_hint': 'Þú skráir þig inn með þessu netfangi.',
    'auth.signup.email_invalid': 'Sláðu inn gilt netfang.',
    'auth.signup.email_taken': 'Þetta netfang er þegar með aðgang. Skráðu þig inn með því eða biddu stjórnanda kórsins um aðstoð.',
    'auth.signup.phone': 'Símanúmer (valfrjálst)',
    'auth.signup.submit': 'Búa til aðgang',
    'auth.signup.busy': 'Bý til aðgang…',
    'auth.signup.done_title': 'Aðgangurinn er tilbúinn!',

    // Home-Screen guide
    'auth.install.title': 'Setja appið á heimaskjá',
    'auth.install.why':
      'Þá opnast appið á öllum skjánum eins og hvert annað app, og nóturnar þínar og glósur virka líka án netsambands.',
    'auth.install.platform': 'Tækið þitt',
    'auth.install.p.ios26': 'iPad / iPhone (iOS 26)',
    'auth.install.p.ios': 'iPad / iPhone (eldra iOS)',
    'auth.install.p.android': 'Android',
    'auth.install.p.desktop': 'Tölva',
    'auth.install.step': 'Skref {n}',
    // iOS, iPadOS and macOS have no Icelandic interface: quote the English label the member
    // actually sees, with the Icelandic meaning in brackets.
    'auth.install.ios26.1':
      'Ýttu á Deila-hnappinn („Share“, ferningur með ör upp) í Safari. Á iPad er hann efst til hægri. Á iPhone gætir þú þurft að ýta fyrst á ⋯ neðst á skjánum.',
    'auth.install.ios26.2':
      'Veldu „Add to Home Screen“ (Bæta á heimaskjá). Ef þú sérð það ekki skaltu skruna niður listann eða ýta á „More“.',
    'auth.install.ios26.3':
      'Gættu þess að kveikt sé á „Open as Web App“ (Opna sem vefapp) og ýttu svo á „Add“ (Bæta við).',
    'auth.install.ios.1':
      'Ýttu á Deila-hnappinn („Share“, ferningur með ör upp) í Safari. Á iPad er hann efst á skjánum, á iPhone neðst.',
    'auth.install.ios.2': 'Skrunaðu niður listann og veldu „Add to Home Screen“ (Bæta á heimaskjá).',
    'auth.install.ios.3': 'Ýttu á „Add“ (Bæta við) efst í horninu.',
    'auth.install.ios_other_browser':
      'Notar þú annan vafra en Safari? Þá er best að opna síðuna í Safari og fylgja skrefunum þar.',
    'auth.install.android.1': 'Ýttu á valmyndina ⋮ efst til hægri í Chrome.',
    'auth.install.android.2':
      'Veldu „Install app“ (Setja upp forrit), eða „Add to Home screen“ (Bæta á heimaskjá) ef hitt er ekki í boði.',
    'auth.install.android.3': 'Staðfestu með því að ýta á „Install“ (Setja upp).',
    'auth.install.android_button': 'Setja upp appið',
    'auth.install.desktop.1':
      'Í Chrome eða Edge: smelltu á uppsetningartáknið hægra megin í veffangastikunni eða veldu „Install…“ (Setja upp…) í valmyndinni.',
    'auth.install.desktop.2': 'Í Safari á Mac: veldu „File“ → „Add to Dock“ (Skrá → Bæta í Dock).',
    'auth.install.desktop.3': 'Staðfestu og opnaðu appið úr Dock eða forritalistanum.',
    'auth.install.open':
      'Lokaðu vafranum og opnaðu appið með kórtákninu á heimaskjánum. Þaðan opnar þú það framvegis.',
    'auth.install.signin_note':
      'Ef appið biður þig um að skrá þig inn notar þú sama netfang og lykilorð og hér.',
    'auth.install.installed_title': 'Appið er á heimaskjánum',
    'auth.install.installed_body': 'Þú ert að nota appið af heimaskjánum. Það þarf ekkert meira að gera.',

    // Avatar editor
    'auth.avatar.choose': 'Velja mynd',
    'auth.avatar.take': 'Taka mynd',
    'auth.avatar.remove': 'Fjarlægja mynd',
    'auth.avatar.remove_confirm': 'Fjarlægja myndina?',
    'auth.avatar.remove_body': 'Upphafsstafirnir þínir birtast þá í staðinn.',
    'auth.avatar.removed': 'Myndin var fjarlægð',
    'auth.avatar.crop_title': 'Stilltu myndina',
    'auth.avatar.crop_hint': 'Dragðu myndina til með fingrinum. Notaðu sleðann eða tvo fingur til að stækka.',
    'auth.avatar.viewport': 'Myndskurður. Dragðu eða notaðu örvatakkana til að færa, + og − til að stækka og minnka.',
    'auth.avatar.zoom': 'Stækkun',
    'auth.avatar.zoom_in': 'Stækka',
    'auth.avatar.zoom_out': 'Minnka',
    'auth.avatar.save': 'Vista mynd',
    'auth.avatar.saved': 'Myndin var vistuð',
    'auth.avatar.loading': 'Opna mynd…',
    'auth.avatar.read_error': 'Ekki tókst að opna myndina. Prófaðu aðra mynd (JPEG eða PNG).',
    'auth.avatar.too_big': 'Myndin er of stór. Veldu minni mynd.',
    // Another member's photo (editors and admins)
    'auth.avatar.member_add': 'Bæta við mynd',
    'auth.avatar.member_add_label': 'Bæta við mynd af {name}',
    'auth.avatar.member_change': 'Breyta mynd',
    'auth.avatar.member_change_label': 'Breyta mynd af {name}',
    'auth.avatar.member_take_label': 'Taka mynd af {name}',
    'auth.avatar.member_remove_label': 'Fjarlægja mynd af {name}',
    'auth.avatar.member_crop_title': 'Mynd af {name}',
    'auth.avatar.member_consent':
      'Settu aðeins inn mynd sem félaginn samþykkir. Félagi með aðgang getur alltaf skipt um myndina eða fjarlægt hana í Stillingum.',
    'auth.avatar.member_inactive_note': 'Óvirkur félagi getur ekki breytt myndinni sjálfur.',
    'auth.avatar.member_remove_confirm': 'Fjarlægja mynd af {name}?',
    'auth.avatar.member_remove_body': 'Upphafsstafirnir birtast þá í staðinn.',
    'auth.avatar.member_saved': 'Mynd af {name} var vistuð',
    'auth.avatar.member_removed': 'Mynd af {name} var fjarlægð',

    // First-run onboarding
    'auth.onb.step_of': 'Skref {n} af {total}',
    'auth.onb.welcome': 'Velkomin(n) í app kórsins!',
    'auth.onb.intro': 'Fjögur stutt skref og þá getur þú byrjað.',
    'auth.onb.sign_out': 'Skrá út',
    'auth.onb.next': 'Áfram',
    'auth.onb.skip': 'Sleppa í bili',
    'auth.onb.finish': 'Ljúka og opna appið',
    'auth.onb.done_toast': 'Allt klárt – velkomin(n)!',
    'auth.onb.name.title': 'Er nafnið þitt rétt?',
    'auth.onb.name.body': 'Svona birtist nafnið þitt hinum í kórnum.',
    'auth.onb.name.label': 'Fullt nafn',
    'auth.onb.name.required': 'Sláðu inn nafnið þitt.',
    'auth.onb.photo.title': 'Mynd af þér',
    'auth.onb.photo.body':
      'Mynd hjálpar hinum í kórnum að þekkja þig. Þú getur líka sleppt þessu og bætt mynd við síðar í Stillingum.',
    'auth.onb.contact.title': 'Símanúmer og netfang',
    'auth.onb.contact.body':
      'Viltu að hinir í kórnum geti haft samband við þig? Aðeins félagar í kórnum sjá þetta, og aðeins ef þú kveikir á því. Þú getur breytt þessu hvenær sem er í Stillingum.',
    'auth.onb.phone': 'Símanúmer',
    'auth.onb.phone_invalid': 'Símanúmerið virðist ekki rétt slegið inn.',
    'auth.onb.share_phone': 'Sýna símanúmerið mitt í félagatalinu',
    'auth.onb.share_phone_hint': 'Sláðu fyrst inn símanúmer hér fyrir ofan.',
    'auth.onb.share_email': 'Sýna netfangið mitt í félagatalinu',
    'auth.onb.email_public': 'Netfang sem birtist',
    'auth.onb.email_public_hint': 'Valfrjálst. Skildu eftir autt til að sýna {email}.',
    'auth.onb.email_invalid': 'Netfangið virðist ekki rétt slegið inn.',
    'auth.onb.admin_note': 'Stjórnendur kórsins sjá alltaf símanúmer og netfang svo þeir geti náð í þig.',
    'auth.onb.lang.title': 'Tungumál',
    'auth.onb.lang.body': 'Á hvaða tungumáli viltu nota appið? Þú getur breytt þessu síðar í Stillingum.',
  },
  {
    // Shared chrome
    'auth.lang.label': 'Language',
    'auth.lang.is': 'Íslenska',
    'auth.lang.en': 'English',
    'auth.tagline': "The choir's music, rehearsals and calendar",
    'auth.logo_alt': 'Karlakór Grafarvogs logo',
    'auth.wait_seconds': {
      one: 'Too many attempts. Try again in {count} second.',
      other: 'Too many attempts. Try again in {count} seconds.',
    },
    'auth.wait_minutes': {
      one: 'Too many attempts. Try again in {count} minute.',
      other: 'Too many attempts. Try again in {count} minutes.',
    },

    // Password field
    'auth.password.show': 'Show password',
    'auth.password.hide': 'Hide password',
    'auth.password.caps': 'Caps Lock is on',

    // Login
    'auth.login.title': 'Sign in',
    'auth.login.email': 'E-mail',
    'auth.login.password': 'Password',
    'auth.login.submit': 'Sign in',
    'auth.login.busy': 'Signing in…',
    'auth.login.slow': 'This can take a few seconds on older devices.',
    'auth.login.missing': 'Enter your e-mail and password.',
    'auth.login.bad_email': 'That e-mail address does not look right.',
    'auth.login.forgot_title': 'Forgot your password?',
    'auth.login.forgot': 'Contact the choir administrator to get a new link.',
    'auth.login.install_link': 'How do I add the app to my Home Screen?',

    // Invite / reset link
    'auth.accept.checking': 'Checking the link…',
    'auth.accept.welcome': 'Welcome, {name}!',
    'auth.accept.invite_intro': 'Choose a password to activate your access to the choir app.',
    'auth.accept.reset_title': 'New password',
    'auth.accept.reset_intro': 'Hi {name}. Choose a new password for your account.',
    'auth.accept.email': 'Your e-mail',
    'auth.accept.email_hint': 'You sign in with this e-mail address.',
    'auth.accept.password': 'New password',
    'auth.accept.repeat': 'Repeat the password',
    'auth.accept.rule': 'At least {min} characters. Tip: a few words together, e.g. "sun horse coffee Esja".',
    'auth.accept.count': '{count} / {min} characters',
    'auth.accept.too_short': 'The password must be at least {min} characters.',
    'auth.accept.too_common': 'That password is too common. Please choose another one.',
    'auth.accept.mismatch': 'The passwords do not match.',
    'auth.accept.submit': 'Save password',
    'auth.accept.busy': 'Saving password…',
    'auth.accept.other_user': 'You are signed in as {name} on this device. If you continue, that account will be signed out here.',
    'auth.accept.invalid_title': 'This link does not work',
    'auth.accept.invalid_body': 'It has expired or has already been used. Ask the choir administrator for a new link.',
    'auth.accept.to_login': 'Go to sign in',
    'auth.accept.done_title': 'Your password is saved!',
    'auth.accept.done_body': 'One more step: add the app to your Home Screen so it is always at hand.',
    'auth.accept.continue_browser': 'Continue in the browser',

    // Invite link by voice (sign up)
    'auth.signup.title': 'Welcome to Karlakór Grafarvogs!',
    'auth.signup.intro': 'Enter your details and choose a password to create your account in the choir app.',
    'auth.signup.voice': 'Section',
    'auth.signup.title_label': 'Title',
    'auth.signup.name': 'Full name',
    'auth.signup.name_required': 'Please enter your name.',
    'auth.signup.email': 'E-mail',
    'auth.signup.email_hint': 'You sign in with this e-mail address.',
    'auth.signup.email_invalid': 'Please enter a valid e-mail address.',
    'auth.signup.email_taken': 'This e-mail already has an account. Sign in with it or ask the choir’s administrator for help.',
    'auth.signup.phone': 'Phone number (optional)',
    'auth.signup.submit': 'Create account',
    'auth.signup.busy': 'Creating account…',
    'auth.signup.done_title': 'Your account is ready!',

    // Home-Screen guide
    'auth.install.title': 'Add the app to your Home Screen',
    'auth.install.why':
      'The app then opens full screen like any other app, and your music and notes also work without an internet connection.',
    'auth.install.platform': 'Your device',
    'auth.install.p.ios26': 'iPad / iPhone (iOS 26)',
    'auth.install.p.ios': 'iPad / iPhone (older iOS)',
    'auth.install.p.android': 'Android',
    'auth.install.p.desktop': 'Computer',
    'auth.install.step': 'Step {n}',
    'auth.install.ios26.1':
      'Tap the Share button in Safari. On iPad it is at the top right. On iPhone you may first need to tap ⋯ at the bottom of the screen.',
    'auth.install.ios26.2': 'Choose "Add to Home Screen". If you cannot see it, scroll down the list or tap "More".',
    'auth.install.ios26.3': 'Make sure "Open as Web App" is switched on, then tap "Add".',
    'auth.install.ios.1':
      'Tap the Share button in Safari (a square with an arrow pointing up). On iPad it is at the top of the screen, on iPhone at the bottom.',
    'auth.install.ios.2': 'Scroll down the list and choose "Add to Home Screen".',
    'auth.install.ios.3': 'Tap "Add" in the top corner.',
    'auth.install.ios_other_browser': 'Using a browser other than Safari? Then it is best to open the page in Safari and follow the steps there.',
    'auth.install.android.1': 'Tap the ⋮ menu at the top right in Chrome.',
    'auth.install.android.2': 'Choose "Install app" (or "Add to Home screen").',
    'auth.install.android.3': 'Confirm by tapping "Install".',
    'auth.install.android_button': 'Install the app',
    'auth.install.desktop.1':
      'In Chrome or Edge: click the install icon at the right of the address bar, or choose "Install…" in the menu.',
    'auth.install.desktop.2': 'In Safari on a Mac: choose File → "Add to Dock".',
    'auth.install.desktop.3': 'Confirm, then open the app from the Dock or your list of apps.',
    'auth.install.open': 'Close the browser and open the app with the choir icon on your Home Screen. Open it from there from now on.',
    'auth.install.signin_note': 'If the app asks you to sign in, use the same e-mail and password as here.',
    'auth.install.installed_title': 'The app is on your Home Screen',
    'auth.install.installed_body': 'You are using the app from your Home Screen. There is nothing more to do.',

    // Avatar editor
    'auth.avatar.choose': 'Choose photo',
    'auth.avatar.take': 'Take photo',
    'auth.avatar.remove': 'Remove photo',
    'auth.avatar.remove_confirm': 'Remove the photo?',
    'auth.avatar.remove_body': 'Your initials will be shown instead.',
    'auth.avatar.removed': 'Photo removed',
    'auth.avatar.crop_title': 'Adjust the photo',
    'auth.avatar.crop_hint': 'Drag the photo with your finger. Use the slider or two fingers to zoom.',
    'auth.avatar.viewport': 'Photo crop. Drag or use the arrow keys to move, + and − to zoom in and out.',
    'auth.avatar.zoom': 'Zoom',
    'auth.avatar.zoom_in': 'Zoom in',
    'auth.avatar.zoom_out': 'Zoom out',
    'auth.avatar.save': 'Save photo',
    'auth.avatar.saved': 'Photo saved',
    'auth.avatar.loading': 'Opening photo…',
    'auth.avatar.read_error': 'Could not open the photo. Try another one (JPEG or PNG).',
    'auth.avatar.too_big': 'The photo is too large. Please choose a smaller one.',
    // Another member's photo (editors and admins)
    'auth.avatar.member_add': 'Add photo',
    'auth.avatar.member_add_label': 'Add photo of {name}',
    'auth.avatar.member_change': 'Change photo',
    'auth.avatar.member_change_label': 'Change photo of {name}',
    'auth.avatar.member_take_label': 'Take photo of {name}',
    'auth.avatar.member_remove_label': 'Remove photo of {name}',
    'auth.avatar.member_crop_title': 'Photo of {name}',
    'auth.avatar.member_consent': 'Only add a photo the member agrees to. A member who can sign in can always replace or remove it in Settings.',
    'auth.avatar.member_inactive_note': "An inactive member can't change the photo themselves.",
    'auth.avatar.member_remove_confirm': 'Remove the photo of {name}?',
    'auth.avatar.member_remove_body': 'Their initials will be shown instead.',
    'auth.avatar.member_saved': 'Photo of {name} saved',
    'auth.avatar.member_removed': 'Photo of {name} removed',

    // First-run onboarding
    'auth.onb.step_of': 'Step {n} of {total}',
    'auth.onb.welcome': 'Welcome to the choir app!',
    'auth.onb.intro': 'Four short steps and you are ready to go.',
    'auth.onb.sign_out': 'Sign out',
    'auth.onb.next': 'Next',
    'auth.onb.skip': 'Skip for now',
    'auth.onb.finish': 'Finish and open the app',
    'auth.onb.done_toast': 'All set – welcome!',
    'auth.onb.name.title': 'Is your name correct?',
    'auth.onb.name.body': 'This is how your name is shown to the others in the choir.',
    'auth.onb.name.label': 'Full name',
    'auth.onb.name.required': 'Please enter your name.',
    'auth.onb.photo.title': 'Your photo',
    'auth.onb.photo.body': 'A photo helps the others in the choir recognise you. You can also skip this and add a photo later in Settings.',
    'auth.onb.contact.title': 'Phone and e-mail',
    'auth.onb.contact.body':
      'Would you like the others in the choir to be able to contact you? Only choir members can see this, and only if you switch it on. You can change it at any time in Settings.',
    'auth.onb.phone': 'Phone number',
    'auth.onb.phone_invalid': 'That phone number does not look right.',
    'auth.onb.share_phone': 'Show my phone number in the member directory',
    'auth.onb.share_phone_hint': 'Enter a phone number above first.',
    'auth.onb.share_email': 'Show my e-mail in the member directory',
    'auth.onb.email_public': 'E-mail to show',
    'auth.onb.email_public_hint': 'Optional. Leave empty to show {email}.',
    'auth.onb.email_invalid': 'That e-mail address does not look right.',
    'auth.onb.admin_note': 'The choir administrators can always see your phone and e-mail so they can reach you.',
    'auth.onb.lang.title': 'Language',
    'auth.onb.lang.body': 'Which language would you like to use the app in? You can change this later in Settings.',
  },
);
